// extracted by mini-css-extract-plugin
export default {"container":"Note_container__4sUY4","title":"Note_title__7s-FZ"};